webpackJsonp([35783957827783],{

/***/ 203:
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var Aux = function Aux(_ref) {
	  var children = _ref.children;
	  return children ? children : null;
	};
	exports.default = Aux;
	module.exports = exports["default"];

/***/ }),

/***/ 206:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(15);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _particles = __webpack_require__(57);
	
	var _particles2 = _interopRequireDefault(_particles);
	
	var _container = __webpack_require__(8);
	
	var _container2 = _interopRequireDefault(_container);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Hero = function Hero(_ref) {
	  var className = _ref.className;
	  return _react2.default.createElement(
	    'div',
	    { className: 'hero-area' },
	    _react2.default.createElement(_particles2.default, null),
	    _react2.default.createElement(
	      _container2.default,
	      { customClassName: 'hero-area-container' },
	      _react2.default.createElement(
	        'h1',
	        null,
	        'Business with purpose'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'We are passionately creating digital experiences and engagement for web and mobile ',
	        _react2.default.createElement('br', null),
	        'through strategy, innovation and dedication.'
	      ),
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '/contact' },
	        _react2.default.createElement(
	          'div',
	          { className: 'button button-white' },
	          'Contact us'
	        )
	      )
	    )
	  );
	};
	
	exports.default = Hero;
	module.exports = exports['default'];

/***/ }),

/***/ 207:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(15);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _container = __webpack_require__(8);
	
	var _container2 = _interopRequireDefault(_container);
	
	var _sectionHeading = __webpack_require__(44);
	
	var _sectionHeading2 = _interopRequireDefault(_sectionHeading);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HomepageInterests = function HomepageInterests(props) {
	  return _react2.default.createElement(
	    "div",
	    { className: "homepage-interests" },
	    _react2.default.createElement(
	      _container2.default,
	      null,
	      _react2.default.createElement(_sectionHeading2.default, {
	        title: "What piques our mind?",
	        description: "Ideas. Disruptive visions that can change the world for the better (even if it\u2019s just the tiniest part of it). We are always on the lookout to partner with equals, with individuals who want to accelerate their business. Currently we are most inspired by topics such as Artificial Intelligence and its application in different areas of our life. But we do not limit our innovational hub to just one branch, we rather spread it across multiple different industries and try to make this world a better place for all its inhabitants."
	      }),
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: "/about" },
	        _react2.default.createElement(
	          "div",
	          { className: "button" },
	          "Read More"
	        )
	      )
	    )
	  );
	};
	
	exports.default = HomepageInterests;
	module.exports = exports["default"];

/***/ }),

/***/ 78:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(15);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _container = __webpack_require__(8);
	
	var _container2 = _interopRequireDefault(_container);
	
	var _sectionHeading = __webpack_require__(44);
	
	var _sectionHeading2 = _interopRequireDefault(_sectionHeading);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProjectItem = function ProjectItem(_ref) {
	  var customClassName = _ref.customClassName,
	      name = _ref.name,
	      title = _ref.title,
	      realURL = _ref.realURL,
	      desc = _ref.desc,
	      path = _ref.path,
	      url = _ref.url;
	  return _react2.default.createElement(
	    "div",
	    { id: path, className: "project-item " + customClassName },
	    _react2.default.createElement(
	      _container2.default,
	      null,
	      _react2.default.createElement(
	        "div",
	        { className: "project-item-content" },
	        _react2.default.createElement(
	          "h4",
	          null,
	          name
	        ),
	        _react2.default.createElement(
	          "h3",
	          null,
	          title
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          desc
	        ),
	        url ? _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: url },
	          _react2.default.createElement(
	            "div",
	            { className: "button-purple" },
	            "Read More"
	          )
	        ) : null
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "project-item-icon" },
	        _react2.default.createElement(
	          "a",
	          { href: realURL, target: "_blank" },
	          _react2.default.createElement("img", { src: "/static/" + path + ".png" })
	        )
	      )
	    )
	  );
	};
	
	var HomepageProjects = function HomepageProjects(props) {
	  return _react2.default.createElement(
	    "div",
	    { className: "homepage-projects" },
	    _react2.default.createElement(
	      _container2.default,
	      null,
	      _react2.default.createElement(_sectionHeading2.default, {
	        title: "Manifesting Genius Through Innovative Strategies",
	        description: "Housing a great amount of international businesses allowed us to generate a high number of projects that speak volumes and transform markets. We break the boarders of comfort zone by tempting the levels of probability. We believe that growth is only a result of well calculated risk. Fueled by the urge for expansion and progress, we create products which are beneficial for developers, clients and business people in general. Here are some of our projects and we are not stopping there.",
	        small: true
	      })
	    ),
	    props.projects.map(function (project, idx) {
	      var css = idx % 2 === 0 ? "default-project" : "alternate-project";
	      return _react2.default.createElement(ProjectItem, _extends({ customClassName: css }, project));
	    })
	  );
	};
	
	exports.default = HomepageProjects;
	module.exports = exports["default"];

/***/ }),

/***/ 208:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(15);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _container = __webpack_require__(8);
	
	var _container2 = _interopRequireDefault(_container);
	
	var _sectionHeading = __webpack_require__(44);
	
	var _sectionHeading2 = _interopRequireDefault(_sectionHeading);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ServiceItem = function ServiceItem(_ref) {
	  var name = _ref.name,
	      desc = _ref.desc,
	      icon = _ref.icon;
	  return _react2.default.createElement(
	    "div",
	    { className: "service-item" },
	    _react2.default.createElement(
	      "div",
	      { className: "service-icon" },
	      _react2.default.createElement("img", { src: "/static/" + icon + ".png" })
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: "service-name" },
	      name
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: "service-desc" },
	      desc
	    )
	  );
	};
	
	var HomepageServices = function HomepageServices(props) {
	  return _react2.default.createElement(
	    "div",
	    { className: "homepage-services" },
	    _react2.default.createElement(
	      _container2.default,
	      null,
	      _react2.default.createElement(_sectionHeading2.default, {
	        title: "Building Transformational Companies",
	        description: "Through insight into a broader market perspective, we assist our partners in becoming giants within their fields of interest by reducing costs, focusing on growth, and creating a cohesive eco-system."
	      }),
	      _react2.default.createElement(
	        "div",
	        { className: "why-work-with-us" },
	        _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            "h3",
	            null,
	            "Improve your business proces"
	          ),
	          _react2.default.createElement(
	            "p",
	            null,
	            "Through insight into a broader market perspective, we assist our partners in becoming giants within their fields of interest by reducing costs, focusing on growth, and creating a cohesive eco-system. The consistent change in the global business environment has made it obligatory for a company to improve their business process. We are here to implement our knowledge where the business process improvement is the only outcome by helping you  to use your resources wisely and by producing products or services of high quality. "
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            "h3",
	            null,
	            "Why work with us?"
	          ),
	          _react2.default.createElement(
	            "p",
	            null,
	            "All major companies often turn to consulting companies in order to improve their strategy and operations. Being objective while assessing your processes only helps with identifying and prioritizing opportunities for business growth. We analyze the market and we help you understand what sets you apart from the competition. By creating a strategy with us we guarantee you will only have positive outcome. To learn more about what we do and our projects feel free to contact us."
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "services-container" },
	        props.services.map(function (service) {
	          return _react2.default.createElement(ServiceItem, _extends({ key: service.name }, service));
	        })
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "services-read-more" },
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: "/consulting" },
	          _react2.default.createElement(
	            "div",
	            { className: "button-purple" },
	            "Read More"
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = HomepageServices;
	module.exports = exports["default"];

/***/ }),

/***/ 209:
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var If = function If(_ref) {
	  var condtion = _ref.condtion,
	      children = _ref.children;
	
	  if (typeof children === "function" && !!condition) {
	    return children();
	  }
	
	  if (Array.isArray(children) && !!condition) {
	    return children;
	  }
	
	  return null;
	};
	
	exports.default = If;
	module.exports = exports["default"];

/***/ }),

/***/ 210:
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var Map = function Map(_ref) {
	  var collection = _ref.collection,
	      children = _ref.children;
	
	  if (!children) {
	    return null;
	  }
	
	  if (Array.isArray(collection)) {
	    return collection.map(function (item) {
	      return children(item);
	    });
	  }
	
	  return null;
	};
	
	exports.default = Map;
	module.exports = exports["default"];

/***/ }),

/***/ 44:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SectionHeading = function SectionHeading(_ref) {
	  var title = _ref.title,
	      description = _ref.description,
	      small = _ref.small;
	  return _react2.default.createElement(
	    "div",
	    { className: "section-heading" },
	    _react2.default.createElement(
	      "h2",
	      { className: small ? "small-heading" : "" },
	      title
	    ),
	    _react2.default.createElement(
	      "p",
	      null,
	      description
	    )
	  );
	};
	
	exports.default = SectionHeading;
	module.exports = exports["default"];

/***/ }),

/***/ 23:
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var SERVICES = exports.SERVICES = [{
	  name: "Artificial Intelligence",
	  desc: "Delving on the potential of AI and its practical use in our day-to-day operations.",
	  icon: "ai-icon"
	}, {
	  name: "Big Data",
	  desc: "Cooperating and managing cloud-based services with scalable data storage and analytics.",
	  icon: "big-data-icon"
	}, {
	  name: "Real-Time Bidding",
	  desc: "Working closely with RTB hosts who track, measure, analyze and gather real-time results.",
	  icon: "rtb-icon"
	}, {
	  name: "Computer Reservation System",
	  desc: "CRS platforms storing and retrieving info related to travel, vehicle rentals, and the like.",
	  icon: "reservation-icon"
	}, {
	  name: "SFM",
	  desc: "Protect your customers and reduce losses from fraud payments.",
	  icon: "sfm-icon"
	}, {
	  name: "Game Development",
	  desc: "Creating gaming environments that transcend real life experiences, while providing users with new dimensions of fun.",
	  icon: "game-dev-icon"
	}, {
	  name: "Affiliate Marketing",
	  desc: "Performance-based ad networks that award affiliates for bringing visitors to different sites, and vice versa.",
	  icon: "marketing-icon"
	}, {
	  name: "Software Development",
	  desc: "Engineering various projects such as software and applications that bring value to users.",
	  icon: "software-icon"
	}];
	
	var PROJECTS = exports.PROJECTS = [{
	  name: "Adwe.com",
	  title: "RTB Platform",
	  desc: "Managing a self-coded Real-Time-Bidding Platform which operates with all ad formats for both mobile and desktop users, handling over 5B daily requests globally. Minute after minute, inventory is being bought and sold through auctions, thus allowing both parties (advertisers and publishers) to seamlessly generate revenue.",
	  path: "adwe",
	  url: "/project/adwe",
	  realURL: "https://adwe.com"
	}, {
	  name: "Abago.com",
	  title: "Flight Search - OTA",
	  desc: "Harboring one of the biggest databases of flights all over the world to help people find, compare, and book economical air fares. The systems we integrate take care of rapid search conduct that automatically serves users with the right and most prominent option for their wished travel dates.",
	  path: "abago",
	  url: "/project/abago",
	  realURL: "https://abago.com"
	  /*
	  {
	    title: "Mobile Development",
	    desc: "Utilizing our in-house 3D engine for Android and iOS platforms which allows developers to easily create 2D and 3D mobile applications in native Android and iOS platforms. Through continuous upgrades and updates, we make sure that only educational and informational apps are being created for our users.",
	    path: "mobile-device",
	  }
	  */
	}];
	
	var MANAGMENT = exports.MANAGMENT = [];
	
	var ADMINISTRATION = exports.ADMINISTRATION = [];

/***/ }),

/***/ 216:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(15);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _aux = __webpack_require__(203);
	
	var _aux2 = _interopRequireDefault(_aux);
	
	var _if = __webpack_require__(209);
	
	var _if2 = _interopRequireDefault(_if);
	
	var _map = __webpack_require__(210);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _hero = __webpack_require__(206);
	
	var _hero2 = _interopRequireDefault(_hero);
	
	var _container = __webpack_require__(8);
	
	var _container2 = _interopRequireDefault(_container);
	
	var _homepageServices = __webpack_require__(208);
	
	var _homepageServices2 = _interopRequireDefault(_homepageServices);
	
	var _homepageProjects = __webpack_require__(78);
	
	var _homepageProjects2 = _interopRequireDefault(_homepageProjects);
	
	var _homepageInterests = __webpack_require__(207);
	
	var _homepageInterests2 = _interopRequireDefault(_homepageInterests);
	
	var _data = __webpack_require__(23);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IndexPage = function IndexPage() {
	  return _react2.default.createElement(
	    'main',
	    null,
	    _react2.default.createElement(_hero2.default, null),
	    _react2.default.createElement(_homepageServices2.default, { services: _data.SERVICES }),
	    _react2.default.createElement(_homepageProjects2.default, { projects: _data.PROJECTS }),
	    _react2.default.createElement(_homepageInterests2.default, null)
	  );
	};
	
	exports.default = IndexPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-5321cd53317991ca6fe5.js